import WaterMarkLogo from "../assets/img/AaysLogo.png";
import favicon from "../assets/img/favicon.png";

const uiConfig = {
  // Sidebar
  sidebarBackgroundColor: "#bb1ccc",
  sidebarBackgroundColorSecondary: "#5e0768",
  sidebarTextColor: "#FFFFFF",

  // Shared icons (sidebar + header menu icon)
  iconColor: "#bb1ccc",

  // Shared primary button color
  buttonColor: "#bb1ccc",

  // AI Data Assistant theme
  aiAssistantPrimaryColor: "#bb1ccc",
  aiAssistantSecondaryColor: "#5e0768",

  // Header branding
  // Set to imported asset from src. You can replace this import with another file.
  headerLogo: WaterMarkLogo,
  // Header logo layout controls
  // Accept number (treated as px) or CSS string (e.g. "220px", "1rem", "8px 12px")
  headerLogoWidth: 120,
  headerLogoHeight: "auto",
  headerLogoPadding: "0px 0px 0px 20px",
  headerLogoMargin: 0,
  headerTitle: "",

  // Favicon
  favicon: favicon,

  //title
  title: "AAYS Insight Platform",
};

export const applyUiConfig = () => {
  if (typeof document === "undefined") {
    return;
  }

  const root = document.documentElement;
  root.style.setProperty(
    "--app-sidebar-bg",
    `linear-gradient(135deg, ${uiConfig.sidebarBackgroundColor || "#A70E13"}, ${
      uiConfig.sidebarBackgroundColorSecondary || uiConfig.sidebarBackgroundColor || "#A70E13"
    })`
  );
  root.style.setProperty("--app-sidebar-text", uiConfig.sidebarTextColor || "#FFFFFF");
  root.style.setProperty("--app-icon-color", uiConfig.iconColor || "#A70E13");
  root.style.setProperty("--app-button-color", uiConfig.buttonColor || "#A70E13");
  root.style.setProperty(
    "--app-ai-assistant-primary",
    uiConfig.aiAssistantPrimaryColor || "#bb1ccc"
  );
  root.style.setProperty(
    "--app-ai-assistant-secondary",
    uiConfig.aiAssistantSecondaryColor || "#bb1ccc"
  );
  root.style.setProperty(
    "--app-ai-assistant-gradient",
    `linear-gradient(135deg, ${
      uiConfig.aiAssistantPrimaryColor || "#bb1ccc"
    }, ${uiConfig.aiAssistantSecondaryColor || "#5e0768"})`
  );

  // Page title
  if (uiConfig.title) {
    document.title = uiConfig.title;
  }

  // Favicon
  if (uiConfig.favicon) {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = uiConfig.favicon;
  }
};

export default uiConfig;
